import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { CurrencyService } from '@spartacus/core'
import { Discounts } from '../../../../../models/discounts.model'

@Component({
  standalone: false,
  selector: 'vs-merge-quote-products',
  templateUrl: './merge-quote-products.component.html',
  styleUrls: ['./merge-quote-products.component.scss'],
})
export class MergeQuoteProductsComponent implements OnInit {
  @Input() product: any
  @Input() productOpen
  @Input() index
  @Input() acceptance
  @Input() checked
  @Output() productChecked = new EventEmitter<any>()
  breakUp = false
  currency: string
  constructor(private currencyService: CurrencyService) {}

  ngOnInit(): void {
    this.currencyService.getActive().subscribe((currency) => {
      this.currency = currency
    })
  }
  toggleProduct() {
    this.productOpen = !this.productOpen
  }
  openViewBreakup() {
    this.breakUp = !this.breakUp
  }
  getFormattedDate(d) {
    var newDate = d.split('-')
    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    var selectedMonthName = months[parseInt(newDate[1]) - 1]
    return newDate[2] + ' ' + selectedMonthName + ', ' + newDate[0]
  }
  changeCheck(event) {
    var obj = {
      checked: this.checked,
      code: this.product?.partNumber,
      index: this.index,
      itemNumber: this.product?.itemNumber,
    }
    this.productChecked.emit(obj)
  }
  closeMenu(event) {
    this.breakUp = false
  }

  getDiscountName(code) {
    return Discounts[code]
  }
  getTotalDiscounts(discounts?, adders?) {
    let totalDisc = 0
    let totalAdds = 0
    for (const disc of discounts) {
      totalDisc += disc.value
    }
    for (const adds of adders) {
      totalAdds += adds.value
    }
    if (this.currency == 'JPY') {
      return (
        (discounts[0]?.formattedValue[0] || adders[0]?.formattedValue[0]) +
        ((totalAdds || 0) - (totalDisc || 0)).toFixed(0)
      )
    } else {
      return (
        (discounts[0]?.formattedValue[0] || adders[0]?.formattedValue[0]) +
        ((totalAdds || 0) - (totalDisc || 0)).toFixed(2)
      )
    }
    // return (
    //   (discounts[0]?.formattedValue[0] || adders[0]?.formattedValue[0]) +
    //   ((totalAdds || 0) - (totalDisc || 0)).toFixed(2)
    // );
  }
}
